import React from 'react';

import { Outlet } from 'react-router-dom';

const WebLayout = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default WebLayout;